import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { fromNetwork } from '@adornis/baseql/symbols.js';
import type { ChancenDynamicClassFormOfFinanzing } from './ChancenDynamicClassFormOfFinanzing.js';

/**
 * @entity FormOfFinancing
 */
@Entity()
export class FormOfFinancing extends MongoEntity {
  public static override _class = 'FormOfFinancing';
  public static override _collectionName = 'forms-of-finanzing';

  constructor(doc: Partial<EntityData<FormOfFinancing>>) {
    super(doc);
    this._id = A.getGloballyUniqueID();
  }

  @Field(type => String, {
    resolve: function (this: FormOfFinancing) {
      return async () => {
        const dynamicEntity = await import('./ChancenDynamicClassFormOfFinanzing');
        const col = await getRawCollection<ChancenDynamicClassFormOfFinanzing>(
          dynamicEntity.ChancenDynamicClassFormOfFinanzing._collectionName,
        );

        const dynamicClass = await col.findOne({ name: this._class.substring(FormOfFinancing._class.length) });
        return dynamicClass?.name;
      };
    },
  })
  public name: Maybe<string>;

  override toObject(
    filterResolved?: boolean,
    visited?: Set<AdornisEntity>,
  ): EntityData<this> & { _id: string; [fromNetwork]?: boolean | undefined } {
    const result = super.toObject(filterResolved, visited);
    if (filterResolved) {
      delete result.name;
    }
    return result;
  }

  override toString() {
    return this.name;
  }
}
